/* KajuReise Karten - Station 2: Vielfalt ueber Bauplaner-Karten zum Swipen.
   Scroll-snap carousel; seeing at least 3 different cards earns the
   'karten' stone (doc: Nutzer exploriert mindestens zwei Bauideen).        */
(function () {
  'use strict';

  var ASSETS = '../kaju-erlebnis-nacht/assets/';
  var CARDS = [
    { img: 'bauplaner-mini-rundbogen-3-gelbe.jpg', name: 'Der erste Bogen', desc: 'Drei Steine, freistehend – der Anfang von allem.' },
    { img: 'bauplaner-doppelbogen.jpg', name: 'Arkade', desc: 'Bögen reihen sich – wie am Aquädukt.' },
    { img: 'bauplaner-bruecke.jpg', name: 'Brücke', desc: 'Spannweite trägt: drüberrollen erlaubt.' },
    { img: 'bauplaner-laterne.jpg', name: 'Laterne', desc: 'Aus Bögen wird ein Turm mit Fenstern.' },
    { img: 'bauplaner-schmetterling.jpg', name: 'Schmetterling', desc: 'Flach gelegt statt hoch gebaut – Legebilder.' },
    { img: 'bauplaner-rakete.jpg', name: 'Rakete', desc: 'Eigene Ideen: dieselben Steine, neue Welten.' }
  ];

  function init() {
    var vp = document.getElementById('karten-viewport');
    var dotsEl = document.getElementById('karten-dots');
    if (!vp) return;

    CARDS.forEach(function (c) {
      var fig = document.createElement('figure');
      fig.className = 'karte';
      fig.innerHTML = '<img loading="lazy" src="' + ASSETS + c.img + '" alt="Bauidee: ' + c.name + '">' +
        '<figcaption><b>' + c.name + '</b><small>' + c.desc + '</small></figcaption>';
      vp.appendChild(fig);
    });

    var dots = [];
    if (dotsEl) {
      CARDS.forEach(function () {
        var d = document.createElement('span');
        d.className = 'karten__dot';
        dotsEl.appendChild(d);
        dots.push(d);
      });
    }

    var seen = {}, seenCount = 0, ticking = false;

    function activeIndex() {
      var mid = vp.scrollLeft + vp.clientWidth / 2;
      var kids = vp.children, best = 0, bd = 1e9;
      for (var i = 0; i < kids.length; i++) {
        var c = kids[i].offsetLeft + kids[i].offsetWidth / 2;
        var d = Math.abs(c - mid);
        if (d < bd) { bd = d; best = i; }
      }
      return best;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var idx = activeIndex();
        dots.forEach(function (d, i) { d.className = 'karten__dot' + (i === idx ? ' is-on' : ''); });
        if (!seen[idx]) {
          seen[idx] = true; seenCount++;
          if (seenCount >= 3 && window.KajuReise) {
            window.KajuReise.earn('karten', '+1 Gratisstein · Entdeckt: ein System, viele Welten.');
          }
        }
      });
    }
    vp.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
